import { StoreAccessor } from "mobx-firelink";
import { emptyArray } from "js-vextensions";
import { GetCharacter } from "../characters";
export const GetEventCharacters = StoreAccessor("GetEventCharacters", s => (event, emptyForLoading = true) => {
    const charIDs = event.characters.Pairs().map(entry => entry.key);
    const chars = charIDs.map(id => GetCharacter(id));
    if (emptyForLoading && chars.Any(a => a == null))
        return emptyArray;
    return chars;
});
export const GetEventMainCharacterIDs = StoreAccessor("GetEventMainCharacterIDs", s => (event) => {
    const mainCharIDs = event.characters.Pairs().filter(a => a.value.main).map(entry => entry.key);
    return mainCharIDs;
});
export const GetEventMainCharacters = StoreAccessor("GetEventMainCharacters", s => (event, emptyForLoading = true) => {
    const chars = GetEventMainCharacterIDs(event).map(id => GetCharacter(id));
    if (emptyForLoading && chars.Any(a => a == null))
        return emptyArray;
    return chars;
});
